import api from "./api";

export const fetchWalletTransactions = async (
    page = 1,
    size = 10
) => {
    try {
        const response = await api.get(
            `/wallet-transaction-management/wallet-transactions?page=${page}&size=${size}`
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server.",
        };
    } catch (error) {
        console.error(
            "Error fetching wallet transactions:",
            error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.message ||
                "Failed to fetch wallet transactions.",
        };
    }
};